import HiddenField from "./HiddenField";
import ImageField from "./ImageField";
import InputField from "./InputField";
import MatrixField from "./MatrixField";
import { MultipleChoiceField } from "./MultiChoiceField";
import RatingField from "./RatingField";
import ScaleField from "./ScaleField";
import SingleChoiceField from "./SingleChoiceField";
import { SelectField } from "./SelectField";
import TextAreaField from "./TextAreaField";
import TextField from "./TextField";
import TitleField from "./TitleField";

export const fieldComponents: Record<string, any> = {
  hidden: HiddenField,
  image: ImageField,
  input: InputField,
  textarea: TextAreaField,
  matrix: MatrixField,
  multiple_choice: MultipleChoiceField,
  rating: RatingField,
  scale: ScaleField,
  single_choice: SingleChoiceField,
  select: SelectField,
  title: TitleField,
  text: TextField,
};
